const tariffsResources = {
  en: {
    tariffs: {
      title: 'Rates',
      subtitle: 'Minimum-maximum insurance rates by insurance classes',
      subtitle2: 'JSC "IC "Alatau City Garant"',
      from: 'from',
      to: 'to',
      perDay: 'per day',
      table1: 'Class code',
      table2: 'Insurance class',
      table3: 'Minimum tariff',
      table4: 'Base insurance rate',
      table5: 'Maximum tariff',
      table6: 'Correction factors',
      table7: 'It is put into effect from (inclusive)',
      'table1.name': 'Voluntary property insurance',
      'table1.item1': 'accident insurance',
      'table1.item2': 'health insurance (DMS)',
      'table1.item3': 'health insurance (MST)',
      'table2.name': 'Voluntary personal insurance',
      'table2.item1': 'insurance automotive transport',
      'table2.item2': 'insurance railway transport ',
      'table2.item3': 'insurance air transport',
      'table2.item4': 'insurance water transport',
      'table2.item5': 'insurance space objects',
      'table2.item6': 'insurance cargo',
      'table2.item7': 'insurance property, except items 3.1-3.6',
      'table2.item8':
        'insurance civil-legal responsibility owners automotive transport',
      'table2.item9':
        'insurance civil-legal responsibility owners air transport',
      'table2.item10':
        'insurance civil-legal responsibility owners water transport',
      'table2.item11':
        'insurance civil-legal responsibility owners space objects',
      'table2.item12': 'insurance professional responsibility',
      'table2.item13':
        'civil liability insurance, except for the classes specified in paragraphs 3.8-3.12 insurance loans',
      'table2.item14': 'insurance guarantees and guarantees',
      'table2.item15': 'insurance from other financial losses',
      'table2.item16': 'loss insurance of financial organizations',
      'table2.item17': 'except for the classes specified in lines 3.14-3.17',
      'table2.item18': 'title insurance',
      'table2.item19': 'insurance judicial expenses',
      tableCoefficients: {
        title1:
          'Correction coefficients for coefficients for the territory of registration of the vehicle for calculating the insurance premium under the OGPO of the Military-technical Complex for 2025',
        title2:
          'Correction coefficients for coefficients for the territory of registration of the vehicle for calculating the insurance premium under the OGPO of the Military-technical Complex for 2024',
        table1: '№',
        table2: 'Name of the region, city of republican significance, capital',
        table3:
          'The amount of the correction factor for the territory of vehicle registration (for the capital, cities of republican and regional significance)',
        table4:
          'Increased by 10% correction factors for coefficients in the territory of vehicle registration',
        download2025:
          'https://api.jgarant.kz/admin/media/Site/CorporateGovernance/coeff_2025_en.pdf',
        download2024:
          'https://api.jgarant.kz/admin/media/Site/CorporateGovernance/coeff_2024_en.pdf',
        download2025name: 'Correction factors for 2025',
        download2024name: 'Correction factors for 2024',
      },
      downloadAll: 'Download the tariff summary',
      downloadAllLink:
        'https://api.jgarant.kz/admin/media/Site/CorporateGovernance/tariff_summary_ru.docx',
    },
  },
  kz: {
    tariffs: {
      title: 'Тарифтер',
      subtitle: '«Alatau City Garant» СК» АҚ',
      subtitle2:
        'Сақтандыру санаттары бойынша ең төменгі-ең жоғары сақтандыру тарифтері',
      from: '-тан',
      to: '-ге',
      perDay: 'Күніне ',
      table1: 'Санат коды',
      table2: 'Сақтандыру санаты',
      table3: 'Ең төменгі тариф',
      table4: 'Базалық сақтандыру тарифі',
      table5: 'Ең жоғарғы тариф',
      table6: 'Түзету коэффициенттері',
      table7: '(қоса алғанда) бастап қолданысқа енгізіледі',
      'table1.name': 'Ерікті жеке сақтандыру',
      'table1.item1': 'жазатайым оқиғалардан сақтандыру',
      'table1.item2': 'ауру жағдайын сақтандыру (ЕМС)',
      'table1.item3': 'медициналық сақтандыру (ТМС)',
      'table2.name': 'Ерікті мүліктік сақтандыру',
      'table2.item1': 'автомобиль көлігін сақтандыру',
      'table2.item2': 'теміржол көлігін сақтандыру',
      'table2.item3': 'әуе көлігін сақтандыру',
      'table2.item4': 'су көлігін сақтандыру',
      'table2.item5': 'ғарыш объектілерін сақтандыру',
      'table2.item6': 'жүктерді сақтандыру',
      'table2.item7': '3.1-3.6-тармақтарды қоспағанда, мүлікті сақтандыру',
      'table2.item8':
        'автомобиль көлігі иелерінің азаматтық-құқықтық жауапкершілігін сақтандыру',
      'table2.item9':
        'әуе көлігі иелерінің азаматтық-құқықтық жауапкершілігін сақтандыру',
      'table2.item10':
        'су көлігі иелерінің азаматтық-құқықтық жауапкершілігін сақтандыру',
      'table2.item11':
        'ғарыш объектілері иелерінің азаматтық-құқықтық жауапкершілігін сақтандыру',
      'table2.item12': 'кәсіби жауапкершілікті сақтандыру',
      'table2.item13':
        '3.8-3.12-тармақтарда көрсетілген санаттарды қоспағанда, азаматтық-құқықтық жауапкершілікті сақтандыру',
      'table2.item14': 'қарыздарды сақтандыру',
      'table2.item15': 'кепілдіктер мен кепілгерліктерді сақтандыру',
      'table2.item16': 'басқа қаржылық шығындардан сақтандыру',
      'table2.item17':
        '3.14-3.17 жолдарында көрсетілген санаттарды қоспағанда, қаржы ұйымдарының шығындарын сақтандыру',
      'table2.item18': 'титулдық сақтандыру',
      'table2.item19': 'сот шығындарын сақтандыру',
      tableCoefficients: {
        title1:
          '2025 жылға арналған КҚИ АҚЖМС бойынша сақтандыру сыйлықақысын есептеу үшін КҚ-ны тіркеу аумағы бойынша коэффициенттерге түзету коэффициенттері',
        title2:
          '2024 жылға арналған КҚИ АҚЖМС бойынша сақтандыру сыйлықақысын есептеу үшін КҚ-ны тіркеу аумағы бойынша коэффициенттерге түзету коэффициенттері',
        table1: '№ р/н',
        table2: 'Облыс, республикалық маңызы бар қала, астана атауы',
        table3:
          'Көлік құралын тіркеу аумағы бойынша түзету коэффициентінің мөлшері (астана, республикалық және облыстық маңызы бар қалалар үшін)',
        table4:
          'Көлік құралын тіркеу аумағы бойынша коэффициенттерге 10%-ға ұлғайтылған түзету коэффициенттері',
        download2025:
          'https://api.jgarant.kz/admin/media/Site/CorporateGovernance/coeff_2025_kz.pdf',
        download2024:
          'https://api.jgarant.kz/admin/media/Site/CorporateGovernance/coeff_2024_kz.pdf',
        download2025name: '2025 жылға түзету коэффициенттері',
        download2024name: '2024 жылға түзету коэффициенттері',
      },
      downloadAll: 'Тарифтер жинағын жүктеп алу',
      downloadAllLink:
        'https://api.jgarant.kz/admin/media/Site/CorporateGovernance/tariff_summary_kz.docx',
    },
  },
  ru: {
    tariffs: {
      title: 'Тарифы',
      subtitle:
        'Минимальные-максимальные страховые тарифы по классам страхования',
      subtitle2: 'АО «СК «Alatau City Garant»',
      from: 'От',
      to: 'до',
      perDay: 'в день',
      table1: 'Код класса',
      table2: 'Класс страхования',
      table3: 'Минимальный тариф',
      table4: 'Базовый страховой тариф',
      table5: 'Максимальный тариф',
      table6: 'Поправочные коэффициенты',
      table7: 'Вводится в действие с (включительно)',
      'table1.name': 'Добровольное личное страхование',
      'table1.item1': 'страхование от несчастных случаев',
      'table1.item2': 'страхование на случай болезни (ДМС)',
      'table1.item3': 'страхование на случай болезни (МСТ)',
      'table2.name': 'Добровольное имущественное страхование',
      'table2.item1': 'страхование автомобильного транспорта',
      'table2.item2': 'страхование железнодорожного транспорта',
      'table2.item3': 'страхование воздушного транспорта',
      'table2.item4': 'страхование водного транспорта',
      'table2.item5': 'страхования космических объектов',
      'table2.item6': 'страхование грузов',
      'table2.item7': 'страхование имущества, за исключением пунктов 3.1-3.6',
      'table2.item8':
        'страхование гражданско-правовой ответственности владельцев автомобильного транспорта',
      'table2.item9':
        'страхование гражданско-правовой ответственности владельцев воздушного транспорта',
      'table2.item10':
        'страхование гражданско-правовой ответственности владельцев водного транспорта',
      'table2.item11':
        'страхования гражданско-правовой ответственности владельцев космических объектов',
      'table2.item12': 'страхования профессиональной ответственности',
      'table2.item13':
        'страхование гражданско-правовой ответственности, за исключением классов, указанных в пунктах 3.8-3.12',
      'table2.item14': 'страхование займов',
      'table2.item15': 'страхование гарантий и поручительств',
      'table2.item16': 'страхование от прочих финансовых убытков',
      'table2.item17':
        'страхование убытков финансовых организаций за исключением классов, указанных в строках 3.14-3.17',
      'table2.item18': 'титульное страхование',
      'table2.item19': 'страхование судебных расходов',
      tableCoefficients: {
        title1:
          'Поправочные коэффициенты к коэффициентам по территории регистрации ТС для расчета страховой премии по ОГПО ВТС на 2025 год',
        title2:
          'Поправочные коэффициенты к коэффициентам по территории регистрации ТС для расчета страховой премии по ОГПО ВТС на 2024 год',
        table1: '№ п/п',
        table2:
          'Наименование области, города республиканского значения, столицы',
        table3:
          'Размер поправочного коэффициента по территории регистрации транспортного средства (для столицы, городов республиканского и областного значения)',
        table4:
          'Увеличенные на 10% поправочные коэффициенты к коэффициентам по территории регистрации транспортного средства',
        download2025:
          'https://api.jgarant.kz/admin/media/Site/CorporateGovernance/coeff_2025_ru.pdf',
        download2024:
          'https://api.jgarant.kz/admin/media/Site/CorporateGovernance/coeff_2024_ru.pdf',
        download2025name: 'Поправочные коэффициенты на 2025 год',
        download2024name: 'Поправочные коэффициенты на 2024 год',
      },
      downloadAll: 'Скачать свод по тарифам',
      downloadAllLink:
        'https://api.jgarant.kz/admin/media/Site/CorporateGovernance/tariff_summary_ru.docx',
    },
  },
};

export default tariffsResources;
